// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  zoneId: __t.u64().primaryKey().name("zone_id"),
  worldId: __t.u64().name("world_id"),
  cellX: __t.i32().name("cell_x"),
  cellZ: __t.i32().name("cell_z"),
  reason: __t.string(),
});
